import cc from 'classcat';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../store';
import { toastAction, ToastState } from '../../store/slices/toast.slice';

export const ToastContainer = () => {
    const toasts = useSelector<RootState, ToastState>(state => state.toast);
    const dispatch = useDispatch();

    const handleClick = (id: string) => () => {
        dispatch(toastAction.hide({ id }));
        setTimeout(() => toastAction.pop({ id }), 200);
    };

    useEffect(() => {
        Object.entries(toasts).forEach(([tKey, tValue]) => {
            if (!tValue.isHidden) {
                const timeout = 5000;
                setTimeout(() => {
                    dispatch(toastAction.pop({ id: tKey }));
                }, timeout);
            }
        });
    }, [toasts, dispatch]);

    const mappedToasts = Object.entries(toasts).map(([tKey, tValue]) => (
        <div
            key={tKey}
            className={cc([
                'toast',
                { toast: tValue.type === 'success' },
                { toast: tValue.type === 'warn' },
                { toast: tValue.type === 'error' },
                { 'toast--hidden': tValue.isHidden },
            ])}
        >
            <div className="toast__header">
                <div className="toast__header--left">
                    {tValue.type === 'success' ? (
                        <img src="/svg/notifications/success.svg" className="toast__image" alt="success icon" />
                    ) : tValue.type === 'warn' ? (
                        <img src="/svg/notifications/warning.svg" className="toast__image" alt="warning icon" />
                    ) : (
                        <img src="/svg/notifications/error.svg" className="toast__image" alt="error icon" />
                    )}
                    <h4 className="toast__title">{tValue.title}</h4>
                </div>
                <button onClick={handleClick(tKey)}>
                    <img src="/svg/notifications/cancel.svg" alt="cancel icon" />
                </button>
            </div>
            <div className="toast__body">
                <p className="paragraph-4 toast__message">{tValue.message}</p>
            </div>
        </div>
    ));

    return <div className="toast-container">{mappedToasts}</div>;
};
